import PropTypes from 'prop-types'
import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLazyQuery } from '@apollo/client'
import { SEARCH_BOAT_LIST } from 'graphql/boat/queries'

export function BoatNameDropdown({ fields, purpose, statusCode, onBoatSelect }) {
    const { t } = useTranslation()
    const [boatList, setBoatList] = useState(null)

    const [getBoatList, { loading: boatListLoading, error: boatListError }] = useLazyQuery(SEARCH_BOAT_LIST, {
        fetchPolicy: 'network-only',
        notifyOnNetworkStatusChange: true,
        onCompleted: data => {
            setBoatList(data?.searchBoat?.boats)
            
            // If there's a selected boat ID and we have the boat list, call onBoatSelect
            if (fields.value && data?.searchBoat?.boats) {
                const selectedBoat = data.searchBoat.boats.find(boat => boat.id === fields.value)
                if (selectedBoat && onBoatSelect) {
                    onBoatSelect(selectedBoat)
                }
            }
        },
    })

    const handleBoatChange = (e) => {
        const selectedBoatId = e.target.value
        const selectedBoat = boatList?.find(boat => boat.id === selectedBoatId)
        
        // Call the original onChange if it exists
        if (fields.onChange) {
            fields.onChange(e)
        }
        
        // Call the onBoatSelect callback with the selected boat's weight config
        if (onBoatSelect && selectedBoat) {
            onBoatSelect(selectedBoat)
        }
    }

    useEffect(() => {
        getBoatList({
            variables: {
                page: {
                    limit: 100,
                    offset: 0,
                },
                name: null,
                searchBoatId: null,
                statusCode: statusCode || null,
            },
        })
    }, [])

    return (
        <>
            {boatListLoading && <div className="flex justify-start items-start bg-white py-2">Loading ....</div>}
            {boatListError && (
                <select>
                    <option value={null}>{t('No data found')}</option>
                </select>
            )}
            {!boatListLoading && !boatListError && boatList?.length === 0 && (
                <select>
                    <option value={null}>{t('No data found')}</option>
                </select>
            )}
            {!boatListLoading && !boatListError && boatList?.length > 0 && (
                <select
                    {...fields}
                    onChange={handleBoatChange}
                    className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-primary sm:max-w-xs sm:text-sm sm:leading-6"
                >
                    {purpose === 'filter' ? (
                        <option value={null}> {t('All')} </option>
                    ) : (
                        <option value="" disabled>
                            {t('All')}{' '}
                        </option>
                    )}
                    {boatList.map(boat => (
                        <option key={boat.id} value={boat.id}>
                            {boat.name.en}
                        </option>
                    ))}
                </select>
            )}
        </>
    )
}

BoatNameDropdown.propTypes = {
    fields: PropTypes.object.isRequired,
    purpose: PropTypes.string,
    statusCode: PropTypes.string,
    onBoatSelect: PropTypes.func,
}
